import { render } from "./AdsList.vue?vue&type=template&id=1dcfbf11"
import script from "./AdsList.vue?vue&type=script&lang=js"
export * from "./AdsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__